<template>
  <div class="session-loading">
    <div class="session-loading__backdrop" />
    <v-card class="session-loading__card" elevation="8">
      <v-layout row wrap align-center class="session-loading__logos">
        <v-flex xs5 sm6>
          <img src="@/assets/logo-bhp.png" alt="BHP" class="session-loading__logo">
        </v-flex>
        <v-flex xs6 sm5 offset-sm1 offset-xs1>
          <img src="@/assets/logo-escondida.png" alt="Escondida" class="session-loading__logo session-loading__logo--escondida">
        </v-flex>
      </v-layout>

      <h1 class="session-loading__title">Activos Críticos</h1>

      <div class="session-loading__spinner">
        <v-progress-circular indeterminate color="primary" size="56" width="5" />
      </div>

      <p class="session-loading__message">{{ message }}</p>
      <p class="session-loading__hint">Preparando su espacio de trabajo</p>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'SessionLoadingScreen',
  props: {
    message: {
      type: String,
      default: 'Cargando sesión…',
    },
  },
};
</script>

<style scoped>
.session-loading {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  overflow: hidden;
}

.session-loading__backdrop {
  position: absolute;
  inset: 0;
  background-image: url('../../assets/fondo.png');
  background-repeat: repeat;
  opacity: 0.35;
}

.session-loading__card {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 420px;
  padding: 48px 40px 40px;
  border-radius: 12px !important;
  border: 2px solid rgba(204, 204, 204, 0.8);
  background-color: rgba(255, 255, 255, 0.98) !important;
  text-align: center;
}

.session-loading__logos {
  margin-bottom: 8px;
}

.session-loading__logo {
  max-width: 100%;
  height: auto;
}

.session-loading__logo--escondida {
  margin-top: 5px;
}

.session-loading__title {
  color: rgb(246, 123, 47);
  font-weight: bold;
  font-size: 25px;
  margin: 24px 0 28px;
  font-family: Roboto, sans-serif;
}

.session-loading__spinner {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.session-loading__message {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  color: #424242;
  font-family: Roboto, sans-serif;
}

.session-loading__hint {
  margin: 8px 0 0;
  font-size: 13px;
  color: #757575;
  font-family: Roboto, sans-serif;
}
</style>
